import axios from 'axios'
import { refreshOrLogout } from '@/utils/session'

// Fábrica compartilhada dos clientes axios. Em um 401 (access token expirado),
// tenta renovar a sessão com o refresh token e repete a requisição original —
// transparente para o usuário. Só desloga se o servidor recusar o refresh
// (sessão realmente encerrada/revogada). No login, 401 = credenciais inválidas.
export default (prefix) => {
    const api = axios.create({
        baseURL: `${process.env.VUE_APP_URL_SERVER}/${prefix}/`,
        headers: {
            authorization: `Bearer ${localStorage.getItem('token')}`,
        }
    })

    api.interceptors.response.use(
        response => response,
        async error => {
            const status = error.response && error.response.status;
            const config = error.config || {};
            const url = config.url || '';

            const isAuthRoute = url.includes('admins/login') || url.includes('admins/refresh');

            if (status === 401 && !isAuthRoute && !config._retry) {
                config._retry = true;
                try {
                    const token = await refreshOrLogout();
                    config.headers = { ...config.headers, authorization: `Bearer ${token}` };
                    return axios(config);
                } catch (refreshError) {
                    // refreshOrLogout já deslogou se a sessão acabou
                }
            }

            return Promise.reject(error);
        }
    )

    return api
}
